import {push} from 'connected-react-router';

import httpClient from 'httpClient';

export const USER_LOGIN = 'User logged in';
export const USER_LOGOUT = 'User logged out';
export const ADD_ERROR = 'Error occurred';
export const REMOVE_ERROR = 'Error dismissed';
export const CLEAR_ERRORS = 'Clear all the errors';
export const TOKEN_REFRESH_STARTED = 'Token is being refreshed';
export const TOKEN_REFRESHED = 'Access token has been refreshed';
export const ADD_SUCCESS_MESSAGE = 'Operation successful';
export const CLEAR_SUCCESS_MESSAGES = 'Clear all the success messages';
export const REMOVE_SUCCESS_MESSAGE = 'Success message removed';
export const SET_CONFIG = 'Config is being set';

export function login(token, userInfo) {
  return {
    type: USER_LOGIN,
    token,
    userInfo,
  };
}

export function logout() {
  return dispatch => {
    dispatch({type: USER_LOGOUT});
    dispatch(push('/logout'));

    window.location = '/logout';
  };
}

export function refreshToken() {
  return async dispatch => {
    dispatch({
      type: TOKEN_REFRESH_STARTED,
    });

    const response = await httpClient.get('/refresh');

    dispatch({
      type: TOKEN_REFRESHED,
      token: response.data,
    });
  };
}

export function setConfig(config) {
  return {
    type: SET_CONFIG,
    config,
  };
}

export function addError(error) {
  return {
    type: ADD_ERROR,
    error,
  };
}

export function removeError(id) {
  return {
    type: REMOVE_ERROR,
    id,
  };
}

export function clearErrors() {
  return {
    type: CLEAR_ERRORS,
  };
}

export function addSuccessMessage(message) {
  return {
    type: ADD_SUCCESS_MESSAGE,
    message,
  };
}

export function clearSuccessMessages() {
  return {
    type: CLEAR_SUCCESS_MESSAGES,
  };
}

export function removeSuccessMessage(id) {
  return {
    type: REMOVE_SUCCESS_MESSAGE,
    id,
  };
}
